<script>
  import { slide } from 'svelte/transition';
  import { flip } from 'svelte/animate';
  export let config = {};
  export let data = {};

  let collapse = [];
  for(let item of data.faqs) {
    collapse.push(false);
  }
  const toggleCollapse = (i) => {
    // console.log(i, collapse[i])
    collapse[i] = !collapse[i];
  }
  // const rotate = (node, { duration = 400 }) => {
  //   console.log('rotate');
	// 	return {
	// 		duration,
	// 		css: t => {
	// 			// const eased = elasticOut(t);
	// 			return `transform: rotate(180deg);`
	// 		}
	// 	};
	// }
</script>

<section class={config.class} data-section="faqs">
  <div class="layout grid">
    <div>
      <h1>FAQs</h1>
    </div>
    {#each data.faqs as faq, i}
    <div class="faq">
      <div class="question pointer">
        <div class="caret" on:click={() => toggleCollapse(i)}>
          <img src="./io/icons8-{collapse[i]? 'collapse' : 'expand'}_arrow.png" alt="{collapse[i]? 'collapse' : 'expand'}" />
          <!-- <img src="./io/icons8-expand_arrow.png" alt="{collapse[i]? 'collapse' : 'expand'}" /> -->
        </div>
        <p on:click={() => toggleCollapse(i)}>{faq.question}</p>
      </div>
      {#if collapse[i]}
      <div class="answer" transition:slide="{{ duration: 200 }}">
        {@html faq.answer}
      </div>
      {/if}
    </div>
    {/each}
  </div>
</section>

<style>
  .grid {
    grid-template-columns: 1fr;
    align-items: start;
  }
  .faq {
    margin-top: 16px;
    border-bottom: 1px solid #ccc;
  }
  .question {
    position: relative;
  }
  .caret {
    position: absolute;
    right: 16px;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .answer {
    margin: 32px 0 24px;
  }
</style>